import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';
import { FormFieldsService } from '@shared/shared/services/form-fields.service';
import { FormField } from '../index';
import { DecorateUntilDestroy, takeUntilDestroyed } from '@skyeng/libs/shared/rxjs';

@DecorateUntilDestroy()
@Component({
  template: '[crm: abstract control]',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldAbstractComponent implements OnInit, OnChanges {
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() field: FormField;

  showClearButton: boolean;

  // eslint-disable-next-line sky/restrict-getter-setter
  get readonlyValue$(): Observable<any> {
    const value = this.formFieldsService.serializeValues(this.parentFormGroup, [this.field])[this.field.key];
    return of(value);
  }

  constructor(protected formFieldsService: FormFieldsService) {}

  ngOnInit(): void {
    if (!this.field.disableToggle) {
      this.toggleDisabled();
      this.toggleClearButton();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.field.disableToggle && changes.field && !changes.field.isFirstChange()) {
      this.toggleDisabled();
    }
  }

  getFormControl(): AbstractControl {
    return this.parentFormGroup.get(this.field.key);
  }

  clearField($event): void {
    $event.stopPropagation();
    this.getFormControl().patchValue(null);
  }

  protected toggleClearButton(): void {
    this.getFormControl()
      .valueChanges.pipe(
        startWith(this.field.value),
        filter(() => this.field.showClearButton === true),
        takeUntilDestroyed(this),
      )
      .subscribe(val => (this.showClearButton = val != null));
  }

  private toggleDisabled(): void {
    const control = this.getFormControl();

    if (this.field.disabled && !control.disabled) {
      control.disable({ emitEvent: !this.field.restrictEmitEventOnToggleDisable });
    } else if (!this.field.disabled && control.disabled) {
      control.enable({ emitEvent: !this.field.restrictEmitEventOnToggleDisable });
    }
  }
}
